import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/mylogo.jpeg'


const _withScopeId = n => (_pushScopeId("data-v-1e7d3a10"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title-bar" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "logo",
    src: _imports_0
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "title" }, "My Online Judge")
], -1))
const _hoisted_2 = ["src"]

import { routes } from "@/router/routes";
import { useRoute, useRouter } from "vue-router";
import { computed, ref } from "vue";
import { useStore } from "vuex";
import checkAccess from "@/access/checkAccess";
import message from "@arco-design/web-vue/es/message";
import { UserControllerService } from "../../generator";


export default /*#__PURE__*/_defineComponent({
  __name: 'GlobalHeader',
  setup(__props) {

const router = useRouter();
//当前路由
const route = useRoute();

//引入全局变量
const store = useStore();

//展示在菜单的路由数组
const visibleRoutes = computed(() => {
  return routes.filter((item, index) => {
    if (item.meta?.hideInMenu) {
      //有hideInMenu属性的就隐藏掉
      return false;
    }
    // 根据当前登录用户权限过滤菜单
    if (!checkAccess(store.state.user.loginUser, item.meta?.access as string)) {
      //没有相应权限就不展示
      return false;
    }
    return true;
  });
});

//默认选中的为主页
const selectedKeys = ref(["/"]);
//路由跳转后，更新选中的菜单项
router.afterEach((to, from, failure) => {
  selectedKeys.value = [to.path];
});

const doMenuClick = (key: string) => {
  router.push({
    path: key,
  });
};
const logout = async () => {
  const res = await UserControllerService.userLogoutUsingPost();
  if (res.code == 0) {
    message.success("退出成功");
    router.push({
      path: "/user/login",
    });
  } else {
    message.error("退出失败");
  }
};

// setTimeout(() => {
//   store.dispatch("user/getLoginUser", {
//     username: "li",
//     userRole: ACCESS_EMUM.ADMIN,
//   });
// }, 3000);

return (_ctx: any,_cache: any) => {
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_IconEdit = _resolveComponent("IconEdit")!
  const _component_a_avatar = _resolveComponent("a-avatar")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_doption = _resolveComponent("a-doption")!
  const _component_a_dropdown = _resolveComponent("a-dropdown")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_row = _resolveComponent("a-row")!

  return (_openBlock(), _createBlock(_component_a_row, {
    id: "globalHeader",
    align: "center",
    wrap: false
  }, {
    default: _withCtx(() => [
      _createVNode(_component_a_col, { flex: "auto" }, {
        default: _withCtx(() => [
          _createVNode(_component_a_menu, {
            mode: "horizontal",
            "selected-keys": selectedKeys.value,
            onMenuItemClick: doMenuClick
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_menu_item, {
                key: "0",
                style: { padding: 0, marginRight: '38px' },
                disabled: ""
              }, {
                default: _withCtx(() => [
                  _hoisted_1
                ]),
                _: 1
              }),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleRoutes.value, (item) => {
                return (_openBlock(), _createBlock(_component_a_menu_item, {
                  key: item.path
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.name), 1)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }, 8, ["selected-keys"])
        ]),
        _: 1
      }),
      _createVNode(_component_a_col, { flex: "100px" }, {
        default: _withCtx(() => [
          _createVNode(_component_a_space, null, {
            default: _withCtx(() => [
              _createVNode(_component_a_dropdown, { trigger: "hover" }, {
                content: _withCtx(() => [
                  _createVNode(_component_a_doption, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_button, null, {
                        default: _withCtx(() => [
                          _createTextVNode("个人中心")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_doption, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_button, { onClick: logout }, {
                        default: _withCtx(() => [
                          _createTextVNode("退出登录")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_a_avatar, { "trigger-type": "mask" }, {
                    "trigger-icon": _withCtx(() => [
                      _createVNode(_component_IconEdit)
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("img", {
                        alt: "avatar",
                        src: _unref(store).state.user?.loginUser?.userAvatar
                      }, null, 8, _hoisted_2)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createElementVNode("div", null, _toDisplayString(_unref(store).state.user?.loginUser?.userAccount ?? "未登录"), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})